<!--
 * @Description: 客服转接
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:22:29
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-11 14:28:31
-->
<template>
  <div>
    <div style="text-align: left;font-size: 14px;">
      <span style="color:#808080">{{tableData.length===0?'当前暂无在线客服':'当前在线客服'}}</span>
      <span style="margin-left: 20px;font-size: 16px;cursor: pointer;" @click="getReFlashKefu" title="刷新客服列表">
        <i class="el-icon-refresh"></i>
      </span>
    </div>
    <div style="overflow-y: auto;" v-el-height v-if="tableData.length>0">
      <div v-for="item in tableData" :key="item.id" class="flex flex-align-center" style="margin-top: 20px;background-color: #fff;padding: 20px;border-radius: 10px;">
        <div class="item_image flexShrink0" style="width: 50px;height: 50px">
          <img :src="item.headImage" alt="" style="width:100%;height: 100%;" v-if="item.headImage">
          <div v-else class="avatar-text">{{item.nickName.substring(0,1).toUpperCase()}}</div>
        </div>
        <div style="margin-left: 20px;text-align: left;font-size: 16px;color: #303133;">
          <div>
            <span>客服账号：</span>
            <span>{{item.userName}}</span>
          </div>
          <div>
            <span>客服昵称：</span>
            <span>{{item.nickName}}</span>
          </div>
        </div>
        <div style="margin-left: 20px;color:#66b1ff;cursor: pointer;text-decoration: underline;" @click="kefuTransfer(item)">会话转接</div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {

  data() {
    return {
      tableData: [],
      currentUserId: ''
    }
  },
  mounted() {
    this.getKeFuOnlineList()
  },
  methods: {
    // 刷新客服
    getReFlashKefu() {
      this.$isLoading.show()
      this.$http({
        url: '/getKeFuOnlineList',
        method: 'get'
      }).then((res) => {
        this.$isLoading.close()
        this.tableData = res
        const isHaveBool = this.tableData.length > 0
        if (isHaveBool) {
          this.$message.success(`刷新成功`);
        } else {
          this.$message.warning(`当前暂无在线客服`);
        }
      }).catch(() => {
        this.$isLoading.close()
      })
    },

    // 转接客服
    kefuTransfer(item) {
      this.$confirm(`即将转接给${item.nickName}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          userId: this.currentUserId,
          transferToUserId: item.id
        }
        this.$http({
          url: '/kefuTransfer',
          method: 'post',
          data
        }).then((res) => {
          this.$message.success("会话转接成功");
        })
      }).catch(() => { })
    },

    // 客服
    getKeFuOnlineList() {
      this.$http({
        url: '/getKeFuOnlineList',
        method: 'get'
      }).then((res) => {
        this.tableData = res
      })
    }
  }
}

</script>

<style rel='stylesheet/scss' lang='scss' scoped>
.avatar-text {
  width: 50px;
  height: 50px;
  background-color: #f2f2f2; /* 默认背景色 */
  border-radius: 15%; /* 圆角效果 */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}
</style>